module.exports = __webpack_public_path__ + "static/media/8.181d0ce4.jpg";